'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/components/thirdparty-login-form.js';
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _button = require('@marmalade/button');
var _button2 = _interopRequireDefault(_button);
var _constants = require('@marmalade/contact/lib/constants');
var _form = require('@marmalade/form/lib/components/form');
var _form2 = _interopRequireDefault(_form);
var _input = require('@marmalade/form/lib/components/input');
var _input2 = _interopRequireDefault(_input);
var _splitField = require('@marmalade/form/lib/components/split-field');
var _loading = require('@marmalade/loading');
var _loading2 = _interopRequireDefault(_loading);
var _message = require('@marmalade/message');
var _message2 = _interopRequireDefault(_message);
var _propTypes = require('@marmalade/prop-types');
var _actions = require('@marmalade/query/lib/actions');
var _selectors = require('@marmalade/query/lib/selectors');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _propTypes2 = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reactRouterDom = require('react-router-dom');
var _girlAtDesk = require('../../images/girl-at-desk.svg');
var _girlAtDesk2 = _interopRequireDefault(_girlAtDesk);
var _actions2 = require('../actions');
var _constants2 = require('../constants');
var _selectors2 = require('../selectors');
var _validation = require('../validation');
var _accountPanel = require('./account-panel');
var _accountPanel2 = _interopRequireDefault(_accountPanel);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var formId = _constants2.forms.thirdPartyLogin;
var ThirdPartyLogin = function (_Component) {
  _inherits(ThirdPartyLogin, _Component);
  function ThirdPartyLogin() {
    var _ref,
      _this2 = this;
    var _temp, _this, _ret;
    _classCallCheck(this, ThirdPartyLogin);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThirdPartyLogin.__proto__ || Object.getPrototypeOf(ThirdPartyLogin)).call.apply(_ref, [this].concat(args))), _this), _this.verifyThirdparty = function () {
      var _this$props = _this.props,
        verifyThirdparty = _this$props.verifyThirdparty,
        product = _this$props.product,
        verificationDetails = _this$props.verificationDetails;
      var hash = verificationDetails.hash,
        policyId = verificationDetails.policyId;
      verifyThirdparty(product, hash, policyId);
    }, _this.handleSubmit = function (formState) {
      if (!formState.validAndPristine) return;
      var _this$props2 = _this.props,
        loginThirdparty = _this$props2.loginThirdparty,
        product = _this$props2.product,
        verificationDetails = _this$props2.verificationDetails;
      var hash = verificationDetails.hash,
        policyId = verificationDetails.policyId;
      var _formState$values = formState.values,
        firstName = _formState$values.firstName,
        lastName = _formState$values.lastName,
        dateOfBirth = _formState$values.dateOfBirth,
        addressPostcode = _formState$values.addressPostcode;
      var formatDate = function formatDate(_ref2) {
        var _ref3 = _slicedToArray(_ref2, 3),
          dd = _ref3[0],
          mm = _ref3[1],
          yyyy = _ref3[2];
        return yyyy + '-' + mm + '-' + dd;
      };
      loginThirdparty(product, hash, policyId, firstName, lastName, formatDate(dateOfBirth), addressPostcode);
    }, _this.renderError = function (message) {
      return _react2.default.createElement(_message2.default, {
        type: 'warning',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 99
        },
        __self: _this2
      }, _react2.default.createElement(_glamorous2.default.P, {
        css: {
          fontWeight: 'bold'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 100
        },
        __self: _this2
      }, message), _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 101
        },
        __self: _this2
      }, 'Please check and correct the details or give us a call on ', _constants.phone[_this.props.product], '.'));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(ThirdPartyLogin, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.loggedIn) {
        this.props.history.push(this.props.redirect);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
        logout = _props.logout,
        verificationDetails = _props.verificationDetails,
        setQueries = _props.setQueries;

      // Use logout to clear all state ensuring no stale data

      logout();
      // Logout also clears the url queries (hash, policyId) in redux so they need to be re-set afterwards
      // so they are not lost
      setQueries(verificationDetails);

      // Check the hash and policyId are valid before displaying the form
      this.verifyThirdparty();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // This is triggered after a successful login attempt
      if (nextProps.loggedIn) {
        this.props.history.push(this.props.redirect);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
        isVerifying = _props2.isVerifying,
        isVerified = _props2.isVerified,
        isLoggingIn = _props2.isLoggingIn,
        loginError = _props2.loginError;
      var disableForm = !isVerified;
      var hasLoginError = Boolean(loginError);
      if (isVerifying) {
        return _react2.default.createElement(_loading2.default, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 111
          },
          __self: this
        });
      }
      if (!isVerified) {
        return _react2.default.createElement(_accountPanel2.default, {
          img: _girlAtDesk2.default,
          alt: 'Girl at desk',
          icon: 'lock',
          title: 'Log in',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 116
          },
          __self: this
        }, this.renderError('We’re sorry, we can’t verify the link provided.'));
      }
      return _react2.default.createElement(_accountPanel2.default, {
        img: _girlAtDesk2.default,
        alt: 'Girl at desk',
        icon: 'lock',
        title: 'Log in',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 123
        },
        __self: this
      }, _react2.default.createElement(_message2.default, {
        type: 'help',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 124
        },
        __self: this
      }, 'Please verify a few details about the learner driver to access the account to make changes to renew the policy'), _react2.default.createElement(_form2.default, {
        id: formId,
        handleSubmit: this.handleSubmit,
        validator: _validation.thirdpartyLoginValidator,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 129
        },
        __self: this
      }, hasLoginError && this.renderError('We’re sorry, we can’t verify the information provided.'), _react2.default.createElement(_input2.default, {
        label: 'Let us know the learner\'s first name(s)',
        name: 'firstName',
        disabled: disableForm,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 131
        },
        __self: this
      }), _react2.default.createElement(_input2.default, {
        label: 'Let us know the learner\'s surname',
        name: 'lastName',
        disabled: disableForm,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 132
        },
        __self: this
      }), _react2.default.createElement(_splitField.Date, {
        label: 'Let us know their date of birth (DD/MM/YYYY)',
        name: 'dateOfBirth',
        disabled: disableForm,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 133
        },
        __self: this
      }), _react2.default.createElement(_input2.default, {
        label: 'Let us know the learner\'s postcode',
        name: 'addressPostcode',
        disabled: disableForm,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 138
        },
        __self: this
      }), _react2.default.createElement(_glamorous2.default.Div, {
        css: {
          textAlign: 'center'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 139
        },
        __self: this
      }, isLoggingIn ? _react2.default.createElement(_loading2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 141
        },
        __self: this
      }) : _react2.default.createElement(_button2.default, {
        type: 'submit',
        prominence: 'primary',
        text: 'Proceed to portal',
        block: true,
        disabled: disableForm,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 143
        },
        __self: this
      }))));
    }
  }]);
  return ThirdPartyLogin;
}(_react.Component);
ThirdPartyLogin.propTypes = {
  // user
  product: _propTypes.product.isRequired,
  // withRouter
  history: _propTypes.history.isRequired,
  location: _propTypes.location.isRequired,
  // dtp
  loginThirdparty: _propTypes2.func.isRequired,
  verifyThirdparty: _propTypes2.func.isRequired,
  logout: _propTypes2.func.isRequired,
  setQueries: _propTypes2.func.isRequired,
  // stp
  isLoggingIn: _propTypes2.bool.isRequired,
  loginError: _propTypes2.string.isRequired,
  loggedIn: _propTypes2.bool.isRequired,
  verificationDetails: (0, _propTypes2.shape)({
    hash: _propTypes2.string,
    policyId: _propTypes2.string
  }).isRequired,
  isVerifying: _propTypes2.bool.isRequired,
  isVerified: _propTypes2.bool.isRequired,
  thirdpartyVerifyError: _propTypes2.string.isRequired,
  redirect: _propTypes2.string.isRequired
};
exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state) {
  return {
    verificationDetails: {
      hash: (0, _selectors.queries)(state).hash,
      policyId: (0, _selectors.queries)(state).policyId
    },
    isVerifying: (0, _selectors2.isVerifying)(state),
    isVerified: (0, _selectors2.isVerified)(state),
    isLoggingIn: (0, _selectors2.isLoggingIn)(state),
    loginError: (0, _selectors2.loginError)(state),
    loggedIn: (0, _selectors2.isLoggedIn)(state)
  };
}, {
  loginThirdparty: _actions2.loginThirdparty,
  logout: _actions2.logout,
  verifyThirdparty: _actions2.verifyThirdparty,
  setQueries: _actions.setQueries
})(ThirdPartyLogin));